import { BaseMutations } from '@/store/base-mutations';
import {
  SoftwareLicenses,
  SoftwareLicensesFilters,
  SoftwareLicensesStatuses,
  SoftwareLicenseHistory,
  SoftwareLicenseCategories,
  SoftwareCartHistory,
} from '@/modules/software-licenses/types';
import { PaginationProps, TableOptions } from '@/types';
import SoftwareLicensesState from './state';
import { default_software_license, default_software_licenses_history_filters } from '../services';

export default class SoftwareLicensesMutations extends BaseMutations<SoftwareLicensesState> {
  SET_SOFTWARE_LICENSES(software_licenses: SoftwareLicenses.SoftwareLicense[]) {
    this.state.software_licenses = software_licenses;
  }

  SET_SOFTWARE_LICENSES_HISTORY(software_licenses_history: SoftwareLicenseHistory[]) {
    this.state.software_licenses_history = software_licenses_history;
  }

  SET_SOFTWARE_CART_HISTORY(software_cart_history: SoftwareCartHistory[]) {
    this.state.software_cart_history = software_cart_history;
  }

  UPD_FILTER_KEY({ key, value }: { key: keyof SoftwareLicensesFilters, value: unknown }) {
    this.state.filters[key] = value;
  }

  UPD_FILTER_HISTORY_KEY({ key, value }: { key: keyof SoftwareLicensesFilters, value: unknown }) {
    this.state.software_licenses_history_filters[key] = value;
  }

  SET_CURRENT_SOFTWARE_LICENSE(software_license: SoftwareLicenses.SoftwareLicense) {
    this.state.current_software_license = software_license;
  }

  RESET_CURRENT_SOFTWARE_LICENSE() {
    this.state.current_software_license = default_software_license();
  }

  SET_CITIES(cities: string[]) {
    this.state.cities = cities;
  }

  SET_STATUSES(statuses: SoftwareLicensesStatuses[]) {
    this.state.statuses = statuses;
  }

  SET_HISTORY_STATUSES(statuses: SoftwareLicensesStatuses[]) {
    this.state.statuses_history = statuses;
  }

  SET_CATEGORIES(categories: SoftwareLicenseCategories[]) {
    this.state.categories = categories;
  }

  SET_IS_SOFTWARE_ORDER_ALLOWED(isSoftwareOrderAllowed: boolean) {
    this.state.is_software_order_allowed = isSoftwareOrderAllowed;
  }

  SET_IS_MODAL_SOFTWARE_ORDER_ALLOWED(val: boolean) {
    this.state.is_modal_software_order_allowed = val;
  }

  TOGGLE_LOADING_SOFTWARE_LICENSES(toggle: boolean) {
    this.state.software_licenses_loading = toggle;
  }

  SET_TABLE_OPTIONS_HISTORY(opts: TableOptions) {
    this.state.table_options_software_licenses_history = opts;
  }

  UPD_TABLE_OPTIONS_HISTORY({ key, value }: { key: keyof TableOptions, value: unknown }) {
    this.state.table_options_software_licenses_history[key] = value;
  }

  UPD_PAGINATION_FIELD_HISTORY({ key, value }: { key: keyof PaginationProps, value: number }) {
    this.state.pagination_software_licenses_history[key] = value;
  }

  CLEAR_FILTERS_HISTORY() {
    this.state.software_licenses_history_filters = default_software_licenses_history_filters();
  }

  UPD_SOFTWARE_LICENSES_SELECTED({ item, value }: { item: SoftwareLicenses.SoftwareLicense, value: boolean }) {
    if (!item) {
      return;
    }

    this.state.software_licenses = this.state.software_licenses.map((license) =>
      (license.id === item.id ? { ...license, selected: value } : license));
  }

  UPD_SOFTWARE_LICENSES_SELECTED_ALL(value: boolean) {
    this.state.software_licenses = this.state.software_licenses.map((license) => ({
      ...license,
      selected: value,
    }));
  }

  SET_NOT_ACTIVE_SOFTWARE_LICENSES(not_active_software_licenses: SoftwareLicenses.NotActiveSoftwareLicense[]) {
    this.state.not_active_software_licenses = not_active_software_licenses;
  }

  SET_NOT_ACTIVE_SOFTWARE_LICENSES_STATUSES(statuses: SoftwareLicenses.NotActiveSoftwareLicenseStatusItem[]) {
    this.state.not_active_software_licenses_statuses = statuses;
  }

  TOGGLE_NOT_ACTIVE_SOFTWARE_LICENSES_LOADING(toggle: boolean) {
    this.state.not_active_software_licenses_loading = toggle;
  }

  UPD_NOT_ACTIVE_SOFTWARE_LICENSES_FILTER_KEY({ key, value }: { key: keyof SoftwareLicenses.NotActiveSoftwareLicensesRequestFilters, value: unknown }) {
    this.state.not_active_software_licenses_filters[key] = value;
  }

  SET_NOT_ACTIVE_SOFTWARE_LICENSES_TABLE_OPTIONS(opts: TableOptions) {
    this.state.not_active_software_licenses_table_options = opts;
  }

  UPD_NOT_ACTIVE_SOFTWARE_LICENSES_TABLE_OPTIONS({ key, value }: { key: keyof TableOptions, value: unknown }) {
    this.state.not_active_software_licenses_table_options[key] = value;
  }

  UPD_NOT_ACTIVE_SOFTWARE_LICENSES_PAGINATION_FIELD({ key, value }: { key: keyof PaginationProps, value: number }) {
    this.state.not_active_software_licenses_pagination_props[key] = value;
  }
}
